/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiScreeningClearanceRuleTestCase,
    ApiScreeningClearanceRuleTestCaseFromJSON,
    ApiScreeningClearanceRuleTestCaseToJSON,
    ApiScreeningClearanceRuleTestResult,
    ApiScreeningClearanceRuleTestResultFromJSON,
    ApiScreeningClearanceRuleTestResultToJSON,
} from '../models';

export interface TestRuleRequest {
    apiScreeningClearanceRuleTestCase: ApiScreeningClearanceRuleTestCase;
}

/**
 * 
 */
export class ScreeningClearanceRuleTestingApi extends runtime.BaseAPI {

    /**
     */
    async testRuleRaw(requestParameters: TestRuleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiScreeningClearanceRuleTestResult>>> {
        if (requestParameters.apiScreeningClearanceRuleTestCase === null || requestParameters.apiScreeningClearanceRuleTestCase === undefined) {
            throw new runtime.RequiredError('apiScreeningClearanceRuleTestCase','Required parameter requestParameters.apiScreeningClearanceRuleTestCase was null or undefined when calling testRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rule-test`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiScreeningClearanceRuleTestCaseToJSON(requestParameters.apiScreeningClearanceRuleTestCase),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiScreeningClearanceRuleTestResultFromJSON));
    }

    /**
     */
    async testRule(requestParameters: TestRuleRequest, initOverrides?: RequestInit): Promise<Array<ApiScreeningClearanceRuleTestResult>> {
        const response = await this.testRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
